<template>
  <div>
    <Banner
      :titulo="banner.title"
      :image="banner.image"
      :respimage="banner.resp_image"
    />
    <section class="SuccessMsg bg-white">
      <div class="container">
        <p>
          Contato enviado com sucesso. <br />
          Em breve entraremos em contato
        </p>

        <div class="button">
          <router-link :to="{ name: 'contato' }">Voltar</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";
import Home from "../home/Home";
import Banner from "../shared/Banner";
import BannerService from "../../domain/bannerService";

export default {
  components: {
    Banner,
    Home
  },
  watch: {
    "$i18n.locale": function() {
      this.init();
    }
  },
  methods: {
    init() {
      Vue.http.headers.common["Content-Language"] = this.$i18n.locale;
      this.bannerService.blocks().then(res => {
        this.banner = res;
        this.banner = this.banner[0];
        return this.banner;
      });
    }
  },
  created() {
    this.bannerService = new BannerService(this.$resource, "CONTATO");

    this.init();
  },

  data() {
    return {
      titulo: "Contato",
      banner: []
    };
  }
};
</script>

<style lang="scss">
.SuccessMsg {
  padding: 60px 0;

  .container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    p {
      font-size: 24px;
      line-height: 36px;
      text-align: center;
    }

    .button {
      margin: 60px 0;
      flex-basis: 100%;
      text-align: center;

      a {
        font-size: 15px;
        background: #3ab8e8;
        padding: 10px 20px 11px 20px;
        color: #ffffff;
        font-weight: 100;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contato/SuccessContact.vue